module.exports = __webpack_public_path__ + "img/fz_deal.19412e17.png";